import * as Yup from "yup";
import getForm from "./form";

const {
  formField: {
    country,
    year,
    ageIntervalStart1,
    ageIntervalStart2,
    ageIntervalStart3,
    ageIntervalStart4,
    ageIntervalMid1,
    ageIntervalMid2,
    ageIntervalMid3,
    ageIntervalMid4,
    incidenceScalingAge1,
    incidenceScalingAge2,
    incidenceScalingAge3,
    incidenceScalingAge4,
    survivalLastYearAge1,
    survivalLastYearAge2,
    survivalLastYearAge3,
    survivalLastYearAge4,
    incidenceRateFirstYear,
    incidenceRateLastYear,
    startYearInsulin,
    lifeExpectancy,
    incidenceRateScaling,
    cumulativesSurvAge1,
    cumulativesSurvAge2,
    cumulativesSurvAge3,
    cumulativesSurvAge4,
    cumulativesInc,
  },
} = getForm();

const validations = Yup.object().shape({
  [country.name]: Yup.string(),
  [year.name]: Yup.number()
    .min(1900, year.errorMinMaxMsg)
    .max(2049, year.errorMinMaxMsg)
    .required(year.errorMsg),

  [ageIntervalStart1.name]: Yup.number()
    .min(0, ageIntervalStart1.errorMinMaxMsg)
    .max(200, ageIntervalStart1.errorMinMaxMsg)
    .required(ageIntervalStart1.errorMsg),
  [ageIntervalStart2.name]: Yup.number()
    .min(0, ageIntervalStart2.errorMinMaxMsg)
    .max(200, ageIntervalStart2.errorMinMaxMsg)
    .required(ageIntervalStart2.errorMsg),
  [ageIntervalStart3.name]: Yup.number()
    .min(0, ageIntervalStart3.errorMinMaxMsg)
    .max(200, ageIntervalStart3.errorMinMaxMsg)
    .required(ageIntervalStart3.errorMsg),
  [ageIntervalStart4.name]: Yup.number()
    .min(0, ageIntervalStart4.errorMinMaxMsg)
    .max(200, ageIntervalStart4.errorMinMaxMsg)
    .required(ageIntervalStart4.errorMsg),

  [ageIntervalMid1.name]: Yup.number()
    .min(0, ageIntervalMid1.errorMinMaxMsg)
    .max(200, ageIntervalMid1.errorMinMaxMsg)
    .required(ageIntervalMid1.errorMsg),
  [ageIntervalMid2.name]: Yup.number()
    .min(0, ageIntervalMid2.errorMinMaxMsg)
    .max(200, ageIntervalMid2.errorMinMaxMsg)
    .required(ageIntervalMid2.errorMsg),
  [ageIntervalMid3.name]: Yup.number()
    .min(0, ageIntervalMid3.errorMinMaxMsg)
    .max(200, ageIntervalMid3.errorMinMaxMsg)
    .required(ageIntervalMid3.errorMsg),
  [ageIntervalMid4.name]: Yup.number()
    .min(0, ageIntervalMid4.errorMinMaxMsg)
    .max(200, ageIntervalMid4.errorMinMaxMsg)
    .required(ageIntervalMid4.errorMsg),

  [survivalLastYearAge1.name]: Yup.number()
    .min(0.0, survivalLastYearAge1.errorMinMaxMsg)
    .max(1.0, survivalLastYearAge1.errorMinMaxMsg)
    .required(survivalLastYearAge1.errorMsg),
  [survivalLastYearAge2.name]: Yup.number()
    .min(0.0, survivalLastYearAge2.errorMinMaxMsg)
    .max(1.0, survivalLastYearAge2.errorMinMaxMsg)
    .required(survivalLastYearAge2.errorMsg),
  [survivalLastYearAge3.name]: Yup.number()
    .min(0.0, survivalLastYearAge3.errorMinMaxMsg)
    .max(1.0, survivalLastYearAge3.errorMinMaxMsg)
    .required(survivalLastYearAge3.errorMsg),
  [survivalLastYearAge4.name]: Yup.number()
    .min(0.0, survivalLastYearAge4.errorMinMaxMsg)
    .max(1.0, survivalLastYearAge4.errorMinMaxMsg)
    .required(survivalLastYearAge4.errorMsg),

  [incidenceScalingAge1.name]: Yup.number()
    .min(0.0, incidenceScalingAge1.errorMinMaxMsg)
    .max(10.0, incidenceScalingAge1.errorMinMaxMsg)
    .required(incidenceScalingAge1.errorMsg),
  [incidenceScalingAge2.name]: Yup.number()
    .min(0.0, incidenceScalingAge2.errorMinMaxMsg)
    .max(10.0, incidenceScalingAge2.errorMinMaxMsg)
    .required(incidenceScalingAge2.errorMsg),
  [incidenceScalingAge3.name]: Yup.number()
    .min(0.0, incidenceScalingAge3.errorMinMaxMsg)
    .max(10.0, incidenceScalingAge3.errorMinMaxMsg)
    .required(incidenceScalingAge3.errorMsg),
  [incidenceScalingAge4.name]: Yup.number()
    .min(0.0, incidenceScalingAge4.errorMinMaxMsg)
    .max(10.0, incidenceScalingAge4.errorMinMaxMsg)
    .required(incidenceScalingAge4.errorMsg),

  [incidenceRateFirstYear.name]: Yup.number()
    .min(0.0, incidenceRateFirstYear.errorMinMaxMsg)
    .max(100.0, incidenceRateFirstYear.errorMinMaxMsg)
    .required(incidenceRateFirstYear.errorMsg),
  [incidenceRateLastYear.name]: Yup.number()
    .min(0.0, incidenceRateLastYear.errorMinMaxMsg)
    .max(100.0, incidenceRateLastYear.errorMinMaxMsg)
    .required(incidenceRateLastYear.errorMsg),

  [startYearInsulin.name]: Yup.number()
    .min(1900, startYearInsulin.errorMinMaxMsg)
    .max(2048, startYearInsulin.errorMinMaxMsg)
    .required(startYearInsulin.errorMsg),

  [lifeExpectancy.name]: Yup.number()
    .min(0, lifeExpectancy.errorMinMaxMsg)
    .max(100, lifeExpectancy.errorMinMaxMsg)
    .required(lifeExpectancy.errorMsg),

  [incidenceRateScaling.name]: Yup.number()
    .min(0, incidenceRateScaling.errorMinMaxMsg)
    .max(200000, incidenceRateScaling.errorMinMaxMsg)
    .required(incidenceRateScaling.errorMsg),

  [cumulativesSurvAge1.name]: Yup.array()
    .of(
      Yup.number()
        .min(0.0, cumulativesSurvAge1.errorMinMaxMsg)
        .max(1.0, cumulativesSurvAge1.errorMinMaxMsg)
    )
    .required(cumulativesSurvAge1.errorMsg),
  [cumulativesSurvAge2.name]: Yup.array()
    .of(
      Yup.number()
        .min(0.0, cumulativesSurvAge2.errorMinMaxMsg)
        .max(1.0, cumulativesSurvAge2.errorMinMaxMsg)
    )
    .required(cumulativesSurvAge2.errorMsg),
  [cumulativesSurvAge3.name]: Yup.array()
    .of(
      Yup.number()
        .min(0.0, cumulativesSurvAge3.errorMinMaxMsg)
        .max(1.0, cumulativesSurvAge3.errorMinMaxMsg)
    )
    .required(cumulativesSurvAge3.errorMsg),
  [cumulativesSurvAge4.name]: Yup.array()
    .of(
      Yup.number()
        .min(0.0, cumulativesSurvAge4.errorMinMaxMsg)
        .max(1.0, cumulativesSurvAge4.errorMinMaxMsg)
    )
    .required(cumulativesSurvAge4.errorMsg),

  [cumulativesInc.name]: Yup.array()
    .of(
      Yup.number().min(0.0, cumulativesInc.errorMinMaxMsg).max(1.0, cumulativesInc.errorMinMaxMsg)
    )
    .required(cumulativesInc.errorMsg),
});

export default validations;
